import { render } from "./LinkPreview.vue?vue&type=template&id=2d61042a"
import script from "./LinkPreview.vue?vue&type=script&lang=js"
export * from "./LinkPreview.vue?vue&type=script&lang=js"

import "./LinkPreview.vue?vue&type=style&index=0&id=2d61042a&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__